import { z } from 'zod';

const CommunityGoalServerMessageSchema = z.object({
  completedLevels: z.number(),
  currentPointsInLevel: z.number(),
  totalPointsToNextLevel: z.number().optional(),
  rewardsUnlocked: z.string().array(), // sorted in level order (e.g., index 0 = level 1 reward, index 1 = level 2 reward, etc)
});
export type CommunityGoalServerMessage = z.infer<typeof CommunityGoalServerMessageSchema>;
